import axios from 'axios';
import normalize from 'jsonapi-normalizer';
import {
  Auth
} from 'aws-amplify';

const api = axios.create({
  baseURL: process.env.REACT_APP_API,
  headers: {
    'Content-Type': 'application/vnd.api+json',
    'Accept': 'application/vnd.api+json',
  }
});

export const doRequest = async ({
  url,
  method = 'GET',
  data = {},
  params = {},
  doNormalize = true
}) => {
  const session = await Auth.currentSession();
  const {
    accessToken: {
      jwtToken
    }
  } = session;

  const response = await api.request({
    url,
    method,
    data,
    params,
    headers: {
      'Authorization': `Bearer ${jwtToken}`
    }
  });
  const json = response.data;

  if (0 === json.length) {
    return true;
  }

  if (!doNormalize) {
    return json;
  }

  return normalize(json);
};

const UNKNOWN_ERROR = 'Unknown error.';

export const doError = error => {
  if (!error.response) {
    return UNKNOWN_ERROR;
  }

  const response = error.response;

  try {
    if (response.data && response.data.data && response.data.data.message) {
      return response.data.data.message;
    }

    return UNKNOWN_ERROR;
  } catch (error) {
    return UNKNOWN_ERROR;
  }
};


// WEBPACK FOOTER //
// ./src/services/api/common.js